import { makeAutoObservable } from "mobx";
import type { CreatePasswordReq, NewPasswordReq } from "../../services/APIService/types";
import { LoaderShelf } from "../../shelves";
import type { AuthenticationStore } from "../Authentication";
import type { FintechRegisterStore } from "../FintechRegisterStore";
import type { ValidationOTPStore } from "../ValidationOTPStore";
import { api } from "../../services";

interface AlterTransactionPasswordRes {
	success: boolean;
}

export class PasswordStore {
	public authentication: AuthenticationStore;
	public fintechRegisterStore: FintechRegisterStore;
	public validationOTPStore: ValidationOTPStore;
	public loader = new LoaderShelf();

	constructor(authentication: AuthenticationStore, fintechRegisterStore: FintechRegisterStore, validationOTPStore: ValidationOTPStore) {
		this.authentication = authentication;
		this.fintechRegisterStore = fintechRegisterStore;
		this.validationOTPStore = validationOTPStore;
		makeAutoObservable(this);
	}

	// Método para alteração de senha
	public sendNewTransactionPassword = async (password: string): Promise<AlterTransactionPasswordRes> => {
		const validationId: string = this.validationOTPStore.getValidationId;
		const authenticity = await this.validationOTPStore.getAuthenticity();

		const body: NewPasswordReq = {
			type: "TRANSACTION_PASSWORD",
			newPassword: password,
			authenticity,
		};

		try {
			this.loader.start();
			await api.pathNewTransactionPassword(this.authentication.getToken() || "", validationId, body);

			return { success: true };
		} catch (error) {
			this.validationOTPStore.remainingValidationAttempts.set(this.validationOTPStore.remainingValidationAttempts.value - 1);
			return { success: false };
		} finally {
			this.loader.end();
		}
	};

	// Método para criação de senha
	public sendTransactionPassword = async (password: string): Promise<AlterTransactionPasswordRes> => {
		const body: CreatePasswordReq = {
			type: "TRANSACTION_PASSWORD",
			password,
		};

		try {
			this.loader.start();
			await api.postTransactionPassword(this.authentication.getToken() || "", body);

			return { success: true };
		} catch (error) {
			return { success: false };
		} finally {
			this.loader.end();
		}
	};
}
